// House of You scroll reveal. Unlike Dawn's own scroll-trigger system, this
// never hides content in the markup or base CSS — the "hidden, about to
// reveal" state is applied by this script only, once it has actually run.
// A visitor with JavaScript blocked or failed simply sees the content
// visible from the start, per BEVEGELSE.md.
(function () {
  function initHoyReveal(root) {
    var elements = (root || document).querySelectorAll('.hoy-reveal:not(.hoy-reveal--observed)');
    if (!elements.length) return;

    if (!('IntersectionObserver' in window)) {
      elements.forEach(function (el) {
        el.classList.add('hoy-reveal--observed');
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries, obs) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.remove('hoy-reveal--pending');
            entry.target.classList.add('hoy-reveal--visible');
            obs.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '0px 0px -50px 0px' }
    );

    elements.forEach(function (el) {
      el.classList.add('hoy-reveal--observed', 'hoy-reveal--pending');
      observer.observe(el);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initHoyReveal(document);
  });

  if (Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (event) {
      initHoyReveal(event.target);
    });
  }
})();
